import { createContext } from 'react';
import type { IAuthenticatedCPUser } from '@/lib/types/Auth';
import type { CustomerInfoData, CustomerAllData } from '@/lib/types/Customer';

export interface AuthContextValue {
  // Auth state
  authData: IAuthenticatedCPUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;

  // Customer state
  customerInfo: CustomerInfoData | null;
  selectedCId: number | null;
  selectedCustomer: CustomerAllData | null;
  subcustomers: CustomerAllData[];

  // Derived permissions
  canAccessSubAccounts: boolean;
  isSubaccount: boolean;
  isParentAccount: boolean;

  // Actions
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  setSelectedCId: (cId: number) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
